import { type LocationContent } from "@/components/location-page";
import { FEES, FIRM } from "@/lib/firm";

export const CONTENT: LocationContent = {
  slug: "kings-beach",
  name: "Kings Beach",
  title: "Kings Beach conveyancing, wills and estate lawyers",
  metaTitle: `Kings Beach Conveyancing & Wills Lawyers | ${FIRM.name}`,
  description: `Fixed-fee conveyancing for Kings Beach units and homes — sales ${FEES.sale} incl. GST, purchases ${FEES.purchase}. Wills, EPOAs and estates too. Call ${FIRM.phone}.`,
  lead: "Kings Beach is unit country. Most contracts we see here are lots in a community titles scheme, which means the body corporate records matter as much as the contract itself.",
  paragraphs: [
    "We are a few minutes away in Golden Beach and act for Kings Beach buyers, sellers, downsizers and investors every week. Whether it is a beachfront apartment, a walk-up unit off Burgess Street or a holiday-let lot, the process is fixed-fee and explained up front.",
    "The most common problem in Kings Beach is a buyer relying on a body corporate disclosure statement without reading the levies, the sinking fund forecast, or the minutes recording a looming special levy for building works.",
    "We also prepare wills, enduring powers of attorney and advance health directives for Kings Beach residents, and act for executors administering local estates.",
  ],
  localNotes: [
    {
      t: "Body corporate records search",
      d: "Levies, the sinking fund balance, insurance, by-laws and committee minutes. A body corporate search before your cooling-off period ends is the single best value check on a unit purchase.",
    },
    {
      t: "Special levies and building works",
      d: "Older beachfront buildings face concrete cancer, balcony and waterproofing works. A levy resolved after settlement is still your bill — the minutes usually flag it well in advance.",
    },
    {
      t: "Short-term letting by-laws",
      d: "If you plan to holiday-let, check whether the scheme's by-laws, the letting agreement and local planning permit it. Assumptions here cost investors real money.",
    },
    {
      t: "Exclusive use areas",
      d: "Car spaces, storage cages and courtyards are often exclusive use rather than part of your lot. We confirm what actually transfers with the unit.",
    },
  ],
  suburbs: ["Caloundra", "Shelly Beach", "Moffat Beach", "Golden Beach", "Dicky Beach"],
  faqs: [
    {
      q: "What should I check before buying a unit at Kings Beach?",
      a: "Order a body corporate records search early. You want the levy history, the sinking fund forecast, the insurance position, the by-laws and at least two years of committee and general meeting minutes so any planned special levy is visible before you are committed.",
    },
    {
      q: "Can I short-term let a Kings Beach apartment?",
      a: "Sometimes. It depends on the scheme's by-laws, whether the building has an on-site letting arrangement, and the planning approval for the building. We check all three before you rely on projected holiday-let income.",
    },
    {
      q: "Do you do fixed-fee unit conveyancing?",
      a: `Yes. Our fee for a residential sale is ${FEES.sale} incl. GST and a purchase is ${FEES.purchase}, agreed before we start. Searches and government fees are disbursements shown separately.`,
    },
  ],
};
